import * as types from '../../action-types';

const setScriptFailure = () => ({
  type: types.SET_NEWPAY_SESSION_DATA,
  scriptLoadFailure: true,
});

const setNewpayScriptFailure = () => (dispatch) => {
  dispatch(setScriptFailure());
};

export default setNewpayScriptFailure;
